import { ProjectViewModel } from "../ViewModel/ProjectViewModel";
import { ProjectState } from "../ViewModel/ProjectState";

export function isProjectReadOnly(project: ProjectViewModel) {
  return project.State !== ProjectState.Sandbox;
}
